import { useEffect } from 'react';
import { closeAnyModal } from '../../features/modals/modals.slice';
import { useAppDispatch } from '../useReduxToolkit';
import { useCallState } from '../useCallState';
import { getIsCallLoading, getIsCallLeaving } from '../useCallState/helpers';

/**
 * The hook is responsible for ensuring that modals are
 * automatically dismissed when call is loading or leaving.
 */
export const useCloseModalOnCallStateChange = (): void => {
  const dispatch = useAppDispatch();
  const { callState } = useCallState();

  useEffect(() => {
    const isLoading = getIsCallLoading(callState);
    const isLeaving = getIsCallLeaving(callState);

    if (isLoading || isLeaving) {
      dispatch(closeAnyModal());
    }
  }, [callState]);
};
